// Meta Pixel — fires PageView on app load
declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    // Already initialized — just refire PageView
    window.fbq('track', 'PageView')
    return
  }

  ;(function (f: any, b: any, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', '779815858431133')
  window.fbq('track', 'PageView')
}
